export default [
    { title: 'Home', icon: 'mdi-home', tooltip: 'Home', route: '/' },
    { title: 'Onboarding', icon: 'mdi-camera-plus', tooltip: 'Iniciar Onboarding', route: '/onboarding' },
    { title: 'Cambiar Password', icon: 'mdi-key-change', tooltip: 'Cambiar mi contraseña', route: '/change-password' },
    { title: 'Consultar Onboarding', icon: 'mdi-chart-box-multiple-outline', tooltip: 'Reporte de onboarding', route: '/onboarding-report' },
];
